module.exports = __webpack_public_path__ + "static/skipper-charters-tour-b-2-f4d92ae5d9a26a5f79c246e021bef45c.jpg";